export const SET_LEAD_FILTER_PARAMS = 'SET_LEAD_FILTER_PARAMS';
export const SET_LOG_FILTER_PARAMS = 'SET_LEAD_FILTER_PARAMS';

export const FILTERS_INIT_STATE = {
    leadFilter: {},
    logFilter: {},
};
